module.exports = __webpack_public_path__ + "img/arrow.7ede7eec.svg";